module.exports = __webpack_public_path__ + "static/media/CONFIRMED_EMAIL_ICON.a5d718e0.png";